import Button from '@components/Button';
import { Collapse } from '@components/Collapse';
import ImageContainer from '@components/ImageContainer';
import Tip from '@components/Tip';
import { $curSandTable } from '@stores/dataStores';
import type { GeneralID } from '@types';
import flexBoxHack from '@utils/flexBoxHack';
import { useStore } from 'effector-react';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { showSceneModal } from '../../../category';
import { isSTMarkerScene } from '../../utils/markerTypeCheck';
import { BatchSceneListItem } from './BatchSceneListItem';

interface Props {
  idList: GeneralID[];
  warning?: boolean;
  onChange: (list: GeneralID[]) => void;
}

export function BatchSceneList({ idList, warning, onChange }: Props) {
  const sandTable = useStore($curSandTable);

  const handleSelect = async () => {
    const selectedIds = (
      sandTable?.markers.map((x) =>
        isSTMarkerScene(x) ? x.data.sceneId : null
      ) ?? []
    ).filter((x): x is GeneralID => !!x);
    const { idSet } = await showSceneModal({
      title: '选择要标记的场景',
      subTitle: '当场景带有GPS信息时，将自动标记到地图沙盘中。',
      disabledIds: selectedIds,
      defaultSelected: new Set(idList),
      allowEmpty: true,
      multiple: true,
    });
    if (!idSet) return;
    onChange(Array.from(idSet));
  };

  const handleDelete = (id: GeneralID) => {
    onChange(idList.filter((x) => x !== id));
  };

  const renderList = () => {
    return (
      <div className="h-full w-full">
        <Scrollbars>
          <div className="flex flex-wrap items-center justify-between p-5">
            {idList.map((id) => (
              <BatchSceneListItem key={id} id={id} onDelete={handleDelete} />
            ))}
            {flexBoxHack(63, 3)}
          </div>
        </Scrollbars>
      </div>
    );
  };

  return (
    <Collapse title="标记场景">
      <ImageContainer
        warning={warning}
        style={{ height: idList.length > 3 ? 156 : 83 }}
        placeholder="选择要添加的场景"
      >
        {!!idList.length && renderList()}
      </ImageContainer>
      <div className="mt-10 flex items-center justify-between">
        <Tip>
          {idList.length ? `共${idList.length}个场景` : '支持多选批量设置'}
        </Tip>
        <Button onClick={handleSelect}>选择场景</Button>
      </div>
    </Collapse>
  );
}
